import { DrawdownStatus } from '../drawdown/interfaces';
export interface IDrawdown {
  closeDate: string;
  credits: number;
  dealId: string;
  dealName?: string;
  projectName?: string;
  members: string;
  status: DrawdownStatus;
  currency?: string; // used only by netquest
}

export interface IDrawdownsState {
  loading: boolean;
  list: IDrawdownStore[];
  totalDocs: number;
  exportList: IDrawdown[];
  exporting: boolean;
}

export interface ITableDrawdown extends IDrawdown {
  id: string;
}

export type IDrawdownStore = IDrawdown;
export const DEFAULT_CURRENCY = 'USD';
